export const nullHandlerOptions = [
  { value: 'reject', label: 'Reject' },
  { value: 'if_true', label: 'Skip and go to Yes branch' },
  { value: 'if_false', label: 'Skip and go to No branch' },
] as {
  value: 'reject' | 'if_true' | 'if_false'
  label: string
}[]
